import $ from 'jquery';
import { component as defineComponent } from 'flightjs';
import trackEvent from '@99designs/common/utils/platform/trackEvent';

export default defineComponent(function() {
    this.attributes({
        formSelector: '#votingform',
        commentSelector: '[data-entry-comment]',
        ratingSelector: '[data-star-rating]',
        submitSelector: '[data-submit]',
        notificationEmailSelector: '[data-notification-email]',
        notificationEmailErrorSelector: '[data-notification-email-error]',
        notificationNameSelector: '[data-notification-name]',
        notificationOfferSelector: '[data-notification-offer]',
    });

    this.trackFeedbackSubmitEvents = function() {
        const emailInput = this.select('notificationEmailSelector');
        const nameInput = this.select('notificationNameSelector');

        const emailVal = emailInput.val() || '';
        const nameVal = nameInput.val() || '';
        const emailShown = emailInput.length > 0;

        trackEvent('Submit Contest Poll Vote', {
            withName: !!nameVal.trim(),
            withEmail: !!emailVal.trim(),
            emailShown,
        });

        const optedInToOffer = this.select('notificationOfferSelector').is(':checked');

        if (optedInToOffer) {
            trackEvent('Opted Into Contest Poll Offer', {
                page: 'vote',
            });
        }
    };

    this.handleSubmit = function(event) {
        const optedInToOffer = this.select('notificationOfferSelector').is(':checked');
        const emailElement = this.select('notificationEmailSelector');
        const emailErrorElement = this.select('notificationEmailErrorSelector');

        if (optedInToOffer && !emailElement.val().trim()) {
            emailElement.addClass('input-text--error');
            emailErrorElement.removeAttr('data-hidden');
            event.preventDefault();
            return;
        }

        emailElement.removeClass('input-text--error');
        emailErrorElement.attr('data-hidden', true);
        this.trackFeedbackSubmitEvents();
    };

    this.hasRating = function() {
        return this.select('ratingSelector').filter(':checked').length;
    };

    this.hasComment = function() {
        var comments = this.select('commentSelector').toArray();

        return comments.some(function(comment) {
            return $.trim($(comment).val()).length > 0;
        });
    };

    this.canSubmit = function() {
        return this.hasRating() || this.hasComment();
    };

    this.updateSubmitButton = function() {
        if (this.canSubmit()) {
            this.enableSubmitButton();
        } else {
            this.disableSubmitButton();
        }
    };

    this.disableSubmitButton = function() {
        this.select('submitSelector')
            .addClass('button--disabled')
            .prop('disabled', 'disabled');
    };

    this.enableSubmitButton = function() {
        this.select('submitSelector')
            .removeClass('button--disabled')
            .prop('disabled', null);
    };

    this.after('initialize', function() {
        this.updateSubmitButton();

        this.on('click', {
            ratingSelector: this.updateSubmitButton,
        });
        this.on('change keyup paste', {
            commentSelector: this.updateSubmitButton,
            notificationEmailSelector: this.updateSubmitButton,
            notificationNameSelector: this.updateSubmitButton,
        });
        this.on('submit', {
            formSelector: this.handleSubmit,
        });
    });
});



// WEBPACK FOOTER //
// ./src/web/js/polls/modules/voting-formV2.js